




































































































































































































































































































































import Vue from 'vue'
import { PlayerGameStatus, Mapper, Connection, Message } from '../types'
import MyCards from './MyCards.vue'
import PlayerList from './PlayerList.vue'
import Applications from './Applications.vue'
import GameMaster from './GameMaster.vue'
import SalaryExpectation from './SalaryExpectation.vue'
import { settings } from '../gameSettings'
import axios from 'axios'
import Pusher from 'pusher-js'

export default Vue.extend({
  name: 'Player',
  props: [
    'name',
    'gameId',
    'isGameMaster',
    'gameMasterUseSalaryExpectations',
    'gameMasterUseEducation',
    'gameMasterUseInitiativeApplication',
  ],
  components: {
    MyCards,
    PlayerList,
    Applications,
    GameMaster,
    SalaryExpectation,
  },
  data: function() {
    return {
      additionalGameElements: {
        useSalaryExpectations: false,
        useEducation: false,
        useInitiativeApplication: false,
      },
      educationActionsLeft: 2,
      initiativeApplicationActionsLeft: 2,
      salaryExpectation: 1,
      availableSalaryExpectations: [1, 2, 3],
      alwaysShowLongMessage: true,
      isLongMessageVisible: true,
      popupMessage: '',
      showPopupMessage: false,
      applications: [] as Array<any>,
      applicationsPicked: [] as Array<string>,
      currentNextButtonPusher: '',
      openedApplications: 0,
      myPick: -1,
      showPicksIndex: {
        applicationIndex: 0,
        pickerIndex: 0,
        currentPickerIndex: 0,
        currentApplicationIndex: 0,
        showPickers: true,
        showingPickers: false,
        showingMatches: false,
      },
      applicationMatchesShown: 0,
      tempCounter: 0,
      status: PlayerGameStatus.gameStarted as PlayerGameStatus,
      theplayerGameStatus: PlayerGameStatus,
      players: [],
      scoring: {} as any,
      pusher: {} as Pusher,
      top: [] as Array<any>,
      flop: [] as Array<any>,
      job: [] as Array<any>,
      connections: {} as Mapper<Connection>,
      myBoss: undefined as string | undefined,
      myInitiativeBoss: '',
      myApplication: {
        top: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
        flop: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
        job: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
      },
    }
  },
  watch: {
    message() {
      this.isLongMessageVisible = this.alwaysShowLongMessage
    },
  },
  computed: {
    message: function(): Message {
      let short = ''
      let long = ''

      switch (this.status) {
        case PlayerGameStatus.gameStarted:
          short = `<div class="section">Hallo ${this.name}!
                  </div><div class="section">Hier oben in der Leiste wirst du (in Kurzform) Schritt für Schritt durch das Spiel geführt. Lies bitte immer, was hier steht.</div>
                  <div class="section">Für ausführlichere Informationen kannst du in den meisten Schritten auf das Fragezeichen am Ende klicken.</div>
                  <div class="section">Jetzt warten wir aber erst einmal, bis alle Spieler/innen eingetrudelt sind.</div>`
          long = `<div class="section">Hallo ${this.name}!</div>
                  <div class="section">Na das hat ja schon mal gut geklappt.</div>
                  <div class="section">In diesem Fenster wird bei jedem Schritt ausführlich erklärt, was du als nächstes tun musst.</div>
                  <div class="section">Eine Kurz-Zusammenfassung findet du nach 
                  dem Schließen dieses Fensters dann auch immer oben auf der Seite im grauen Kasten. Dort kannst du auch jederzeit die Langfassung über ein Klick auf das 
                  Fragezeichen wieder öffnen.</div>
                  <div class="section">Falls du die ausführlichen Erklärungen nicht brauchst, kannst du sie unten für die folgenden Schritte deaktivieren, bzw. über das
                  Fragezeichen auch wieder aktivieren.</div>
                  <div class="section">Aber wenn du dieses Spiel noch nie gespielt hast, solltest du sie erst mal aktiviert lassen..</div>`
          break
        case PlayerGameStatus.waitForConnections:
          short = 'Das Spiel wird gestartet. Einen Moment noch.'
          break
        case PlayerGameStatus.selectAJobAsBoss:
          short = `Wähle einen Job, für den <div class="player miniCard">${
            this.connections[this.name].applicant
          }</div> eine Bewerbung erstellen soll.`
          long = `<div class="section">Hier siehst du all deine Handkarten.</div>
                  <div class="section">Als erstes brauchen wir aber nur die oberen ${
                    settings.initalCards.job
                  } <div class="job miniCard job">JOB-Karten</div>. Wähle hiervon eine Karte (per Klick) aus, für den <div class="player miniCard">${
            this.connections[this.name].applicant
          }</div> dann im nächsten Schritt eine passende Bewerbung erstellen soll, um sich damit bei dir zu bewerben.</div>
                  <div class="section">In diesem Moment sucht sich auch <div class="player miniCard">${
                    this.myBoss
                  }</div> eine JOB-Karte aus, für du die dann mit den übrigen Karten (dann auch mit den TOP- und FLOP-Karten) eine Bewerbung zusammenstellen musst.</div>`
          break
        case PlayerGameStatus.waitForOffer:
          short =
            'Bitte warten, bis alle Spieler/innen einen Job ausgewählt haben (siehe Häckchen vor den Namen in der linken Sidebar).'
          break
        case PlayerGameStatus.createApplication:
          short = `Stelle für <div class="player miniCard">${
            this.myBoss
          }</div> eine Bewerbung als <div class="job miniCard">${
            this.connections[this.myBoss as string].job
          }</div> zusammen.`
          long = `<div class="section"><div class="player miniCard">${
            this.myBoss
          }</div> ist auf der Suche nach einer/einem <div class="job miniCard">${
            this.connections[this.myBoss as string].job
          }</div>.</div>
                  <div class="section">Deine Aufgabe ist es nun, eine Bewerbung zusammenzustellen, 
                  die möglichst gut auf diese Bewerbung passt, so dass <div class="player miniCard">${
                    this.myBoss
                  }</div> sich im
                  nächsten Schritt für deine Bewerbung entscheidet.</div>
                  <div class="section">Hierfür musst du jeweils eine <div class="job miniCard">Job</div>, <div class="top miniCard">Top</div> und 
                  <div class="flop miniCard">Flop</div>-Karte auswählen, die deine/n Bewerber/in als <div class="job miniCard">${
                    this.connections[this.myBoss as string].job
                  }</div> qualifiziert.</div>
                  <div class="section">Insbesondere bei <div class="flop miniCard">Flop</div> geht es also darum, eine vermeintliche Schwäche zu finden,
                  die bei einem/einer <div class="job miniCard">${
                    this.connections[this.myBoss as string].job
                  }</div> als Stärke angesehen werden
                  kann (oder zumindest nicht weiter stört).</div>`
          break
        case PlayerGameStatus.createInitiativeApplication:
          short = `Wähle die Stelle, für die du eine Bewerbung abgeben willst und stelle diese zusammen.<br />Danach musst du mit den verbliebenen Karten noch eine Bewerbung für die Stelle als <div class="job miniCard">${
            this.connections[this.myBoss as string].job
          }</div> zusammenstellen`
          break
        case PlayerGameStatus.selectSalaryExpectations:
          short = `Wähle deine Gehaltsvorstellung`
          long = `<div class="section">Nachdem du die Bewerbung zusammengestellt hast, musst du nun noch die Gehaltsvorstellung auswählen.</div>
                  <div class="section">Abhängig von der gewählten Gehaltsvorstellung, bekommst du dann 1, 2 oder 3 Punkte, wenn deine Bewerbung tatsächlich von <div class="player miniCard">${this.myBoss}</div> ausgewählt wurde.</div>
                  <div class="section">Anfangs stehen dir alle drei Werte (1, 2 und 3) zur Auswahl, in der zweiten Runde dann nur noch die beiden Werte, die du noch nicht gewählt hast. Und in der dritten Runde musst du den verbliebenen Wert nehmen.</div>
                  <div class="section">Danach stehen dir dann wieder alle drei Werte zu Verfügung.</div>
                  <div class="section">Hohe Gehaltsvorstellungen solltest du also dann wählen, wenn du dir sicher bist, korrekt erkannt zu werden. Niedrige dann, wenn deine Bewerbung nicht wirklich auf die Stelle passt.</div>`
          break
        case PlayerGameStatus.waitForApplications:
          short =
            'Bitte warten, bis alle Spieler/innen eine Bewerbung zusammengestellt haben (siehe Häckchen vor den Namen in der linken Sidebar).'
          break
        case PlayerGameStatus.showApplications:
          short = `<div class="player miniCard">${this.currentNextButtonPusher}</div> (zufällig ausgewählt) stellt nun allen Mitspielern die einzelnen Bewerbungen vor.`
          long = `<div class="section">Alle Bewerbungsmappen sind fertiggestellt, nun schauen wir uns diese einmal an.</div>
                  <div class="section">@<div class="player miniCard">${this.currentNextButtonPusher}</div> (zufällig ausgewählt): Kannst du bitte nacheinander auf die 
                  Bewerbungsmappen klicken (wodurch sich diese automatisch auch bei allen anderen öffnen) und dabei jeweils die Bewerbung kurz (wertungsneutral) vorstellen?</div>.`
          break
        case PlayerGameStatus.pickApplication:
          short = `Wähle die Bewerbung aus, die <div class="player miniCard">${
            this.connections[this.name].applicant
          }</div> für die Stelle als <div class="job miniCard">${
            this.connections[this.name].job
          }</div> abgegeben hat.`
          long = `<div class="section">Nachdem nun alle Bewerber vorgestellt sind, muss jeder die Bewerbung finden, die auf die von ihm/ihr ausgeschriebene Stelle abgegeben wurde.</div>
                   <div class="section">Du musst nun daher die Bewerbung finden, die <div class="player miniCard">${
                     this.connections[this.name].applicant
                   }</div> für die Stelle als 
                   <div class="job miniCard">${
                     this.connections[this.name].job
                   }</div> zusammengestellt hat.</div>
                   <div class="section">Theoretisch sollte das die sein, die am besten auf deine Stellenausschreibung passt...</div>`
          break
        case PlayerGameStatus.waitForPicks:
          short =
            'Bitte warten, bis alle Spieler eine Bewerbung ausgewählt haben (siehe Häckchen vor den Namen in der linken Sidebar).'
          break
        case PlayerGameStatus.showPicks:
          long = `<div class="section">Nachdem nun jeder eine Bewerbung ausgewählt hat, gehen wir die Bewerbungsmappen der Reihe nach durch und lassen und von jedem, der sich für diese Mappe entschieden hat,
          erklären, warum dies genau die richtige Bewerbung für die ausgeschriebene Stelle ist.</div>
          <div class="section">Wurden für eine Bewerbung alle Erklärungen abgegeben, schauen wir nach, ob die Bewerbung auch tatsächlich für die Stelle angenommen wurde, für die sie erstellt wurde.</div>
          <div class="section">Folgt hier bitte aufmerksam den Anweisungen im oberen Bereich. Eine/r von euch, muss dann immer auf den "Weiter"-Button klicken, um den nächsten Schritt zu starten</div>`
          break
        case PlayerGameStatus.showResults:
          short = `<div class="section">Unten seht ihr nun die Auflösungen zu allen Bewerbungen (diskutiert drüber!).</div>
                   <div class="section">Und links in der Sidebar gibt es den neuen Punktestand.</div>`
          long = `<div class="section">Links in der Sidebar gibt es nun den aktualisierten Punktestand zu sehen.</div>
                <div class="section">Aber viel interessanter: Zu allen Bewerbungen, die nicht den richtigen Addressaten gefunden haben, wird nun auch noch angezeigt, wer sich damit auf welche Stelle beworben hat.</div>
                <div class="section">Hier könnt ihr gerne nochmal alle der Reihe nach durchgehen und euch vom Urheber erklären lassen, was er/sie sich dabei gedacht hat.</div>`
          break
        case PlayerGameStatus.waitForNewCards:
          short =
            'Eine neue Runde wurde gestartet. Bitte warte, bis die neuen Karten verteilt sind (sollte schneller gehen, als du das hier lesen kannst).'
          break
        default:
          short = `<div class="section">Hier ist was schief gelaufen...</div><div class="section">Unbekannter Status: ${this.status}</div>`
      }
      return {
        short: short,
        long: long,
      }
    },
  },
  methods: {
    sendData(data: any) {
      const url =
        'https://headhunter.donvanone.de/backend/src/headhunter.php?prefix=' +
        this.gameId
      axios.get(url, {
        params: {
          data: data,
        },
      })
    },
    hideLongMessage() {
      this.isLongMessageVisible = false
    },
    showLongMessage() {
      this.isLongMessageVisible = true
    },
    hidePopupMessage() {
      this.showPopupMessage = false
      this.popupMessage = ''
    },
    handleMessage(message: any) {
      switch (message.id) {
        case 'playerList':
          this.players = message.data
          break
        case 'initialCards':
          this.$emit('gameStarted')
          this.top = message.data.initialCards.top
          this.flop = message.data.initialCards.flop
          this.job = message.data.initialCards.job
          this.scoring = message.data.scoring
          this.additionalGameElements.useSalaryExpectations =
            message.data.additionalGameElements.useSalaryExpectations
          this.additionalGameElements.useEducation =
            message.data.additionalGameElements.useEducation
          this.additionalGameElements.useInitiativeApplication =
            message.data.additionalGameElements.useInitiativeApplication
          this.availableSalaryExpectations = [1, 2, 3]

          //this.status = PlayerGameStatus.waitForConnections
          this.startNewRound(message.data.connections)
          break
        case 'useAction': {
          if (message.data.player !== this.name) {
            this.popupMessage +=
              '<div class="player miniCard">' +
              message.data.player +
              '</div> ' +
              message.data.playerMessage +
              '<br /><br />'
            this.showPopupMessage = true
          }
          break
        }
        case 'jobSelected': {
          this.connections[message.data.player].job = message.data.job
          this.tempCounter++
          if (this.tempCounter == this.players.length) {
            this.status = PlayerGameStatus.createApplication
          }
          break
        }
        case 'applicationReady': {
          this.connections[message.data.applicant].ready = true
          break
        }
        case 'allApplicationsReady': {
          this.status = PlayerGameStatus.showApplications
          this.openedApplications = 0
          this.myPick = -1
          this.applications = message.data.applications
          this.currentNextButtonPusher = message.data.currentNextButtonPusher
          break
        }
        case 'pickApplication': {
          this.applicationsPicked.push(message.data.player)
          break
        }
        case 'showApplication': {
          this.applications[message.data.applicationIndex].open = true
          this.openedApplications++
          if (this.openedApplications == this.applications.length) {
            window.setTimeout(() => {
              this.status = PlayerGameStatus.pickApplication
            }, 3000)
          }
          break
        }
        case 'allPicksReady': {
          ;(this.showPicksIndex = {
            applicationIndex: 0,
            currentApplicationIndex: 0,
            pickerIndex: 0,
            currentPickerIndex: 0,
            showPickers: true,
            showingPickers: false,
            showingMatches: false,
          }),
            (this.status = PlayerGameStatus.showPicks)
          this.applications = message.data.applications
          this.currentNextButtonPusher = message.data.currentNextButtonPusher
          this.applicationMatchesShown = 0
          this.doNextShowPicksStep()
          break
        }
        case 'showPickersForApplication': {
          this.applications[message.data.applicationIndex].showPickers = true
          if (
            this.applications[message.data.applicationIndex].pickers.length == 0
          ) {
            // diese Bewerbung hatte keinen Picker -> direkt showingMatches, danach showPickers
            this.applications[message.data.applicationIndex].showPickerIndex = 0
            this.applications[message.data.applicationIndex].showMatch = true
            this.applicationMatchesShown++
            this.showPicksIndex = {
              applicationIndex: message.data.applicationIndex + 1,
              currentApplicationIndex: message.data.applicationIndex,
              pickerIndex: 0,
              currentPickerIndex: 0,
              showPickers: true,
              showingPickers: false,
              showingMatches: true,
            }
          } else {
            this.applications[message.data.applicationIndex].showPickerIndex =
              message.data.pickerIndex
            this.applications = [...this.applications]
            this.currentNextButtonPusher = this.applications[
              message.data.applicationIndex
            ].pickers[message.data.pickerIndex]
            if (
              this.applications[message.data.applicationIndex].pickers.length ==
              message.data.pickerIndex + 1
            ) {
              // das war der letzte Picker --> showingPickers, danach showMatches
              this.showPicksIndex = {
                applicationIndex: message.data.applicationIndex,
                currentApplicationIndex: message.data.applicationIndex,
                pickerIndex: 0,
                currentPickerIndex: message.data.pickerIndex,
                showPickers: false,
                showingPickers: true,
                showingMatches: false,
              }
            } else {
              // es gibt noch mehr Picker --> showingPickers, danach showPickers
              this.showPicksIndex = {
                applicationIndex: message.data.applicationIndex,
                currentApplicationIndex: message.data.applicationIndex,
                pickerIndex: message.data.pickerIndex + 1,
                currentPickerIndex: message.data.pickerIndex,
                showPickers: true,
                showingPickers: true,
                showingMatches: false,
              }
            }
          }
          break
        }
        case 'showMatchForApplication': {
          this.applications[message.data.applicationIndex].showMatch = true
          this.applicationMatchesShown++
          this.showPicksIndex = {
            applicationIndex: message.data.applicationIndex + 1,
            currentApplicationIndex: message.data.applicationIndex,
            pickerIndex: 0,
            currentPickerIndex: 0,
            showPickers: true,
            showingPickers: false,
            showingMatches: true,
          }
          break
        }
        case 'showScoring': {
          this.status = PlayerGameStatus.showResults
          this.scoring = message.data.scoring
          break
        }
        case 'redrawCards': {
          this.top = [...this.top, ...message.data.redrawCards.top]
          this.flop = [...this.flop, ...message.data.redrawCards.flop]
          this.job = [...this.job, ...message.data.redrawCards.job]
          this.startNewRound(message.data.connections)
          break
        }
        case 'getEducationCards': {
          this.top = [...this.top, ...message.data.redrawCards.top]
          this.flop = [...this.flop, ...message.data.redrawCards.flop]
          this.job = [...this.job, ...message.data.redrawCards.job]
          break
        }
        default:
          console.log('unknown id: ' + message.id)
      }
    },
    startNewRound(theConnections: any) {
      this.connections = theConnections
      this.myBoss = Object.keys(this.connections).find(
        (key) => this.connections[key].applicant === this.name
      )
      this.status = PlayerGameStatus.selectAJobAsBoss
      this.tempCounter = 0
      this.applicationsPicked = []
      this.myApplication = {
        top: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
        flop: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
        job: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
      }
    },
    useEducation() {
      this.educationActionsLeft--
      const data = {
        everybody: {
          id: 'useAction',
          data: {
            action: 'education',
            playerMessage:
              'hat die Ordner gewälzt (also die Handkarten komplett ausgetauscht)',
            player: this.name,
            numberOfCards: {
              top: this.top.length,
              flop: this.flop.length,
              job: this.job.length,
            },
          },
        },
      }
      this.top = []
      this.flop = []
      this.job = []
      this.myApplication = {
        top: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
        flop: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
        job: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
      }
      this.sendData(data)
    },
    useInitiativeApplication() {
      this.initiativeApplicationActionsLeft--
      this.status = PlayerGameStatus.createInitiativeApplication
      this.myApplication = {
        top: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
        flop: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
        job: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
      }

      const data = {
        everybody: {
          id: 'useAction',
          data: {
            action: 'initiativeApplication',
            playerMessage:
              ' gibt diese Runde eine zusätzliche Initiativ-Bewerbung ab',
            player: this.name,
          },
        },
      }
      this.sendData(data)
    },
    initiativeApplicationOfferClicked(boss: string) {
      this.myInitiativeBoss = boss
      this.checkApplication()
    },
    jobClicked(index: number, name: string) {
      if (this.status == PlayerGameStatus.selectAJobAsBoss) {
        const data = {
          allPlayers: {
            id: 'jobSelected',
            data: {
              player: this.name,
              job: name,
            },
          },
        }
        this.job.splice(index, 1)
        this.sendData(data)
        this.status = PlayerGameStatus.waitForOffer
      } else if (
        this.status == PlayerGameStatus.createApplication ||
        this.status == PlayerGameStatus.createInitiativeApplication
      ) {
        this.myApplication.job = {
          index: index,
          name: name,
        }
        this.checkApplication()
      }
    },
    topClicked(index: number, name: string) {
      if (
        this.status == PlayerGameStatus.createApplication ||
        this.status == PlayerGameStatus.createInitiativeApplication
      ) {
        this.myApplication.top = {
          index: index,
          name: name,
        }
        this.checkApplication()
      }
    },
    flopClicked(index: number, name: string) {
      if (
        this.status == PlayerGameStatus.createApplication ||
        this.status == PlayerGameStatus.createInitiativeApplication
      ) {
        this.myApplication.flop = {
          index: index,
          name: name,
        }
        this.checkApplication()
      }
    },
    checkApplication() {
      if (this.status == PlayerGameStatus.createApplication) {
        if (
          this.myApplication.top.name &&
          this.myApplication.flop.name &&
          this.myApplication.job.name
        ) {
          if (this.additionalGameElements.useSalaryExpectations) {
            this.status = PlayerGameStatus.selectSalaryExpectations
          } else {
            this.salaryExpectation = 1
            this.sendMyApplication()
          }
        }
      } else if (this.status == PlayerGameStatus.createInitiativeApplication) {
        if (
          this.myApplication.top.name &&
          this.myApplication.flop.name &&
          this.myApplication.job.name &&
          this.myInitiativeBoss
        ) {
          this.salaryExpectation = 2
          this.sendMyInitiativeApplication()
        }
      }
    },
    selectSalaryExpectation(salaryExpectation: number) {
      this.salaryExpectation = salaryExpectation
      this.availableSalaryExpectations.splice(
        this.availableSalaryExpectations.indexOf(salaryExpectation),
        1
      )
      if (this.availableSalaryExpectations.length == 0) {
        this.availableSalaryExpectations = [1, 2, 3]
      }
      this.sendMyApplication()
    },
    sendMyApplication() {
      this.status = PlayerGameStatus.waitForApplications
      const data = {
        everybody: {
          id: 'applicationReady',
          data: {
            applicant: this.name,
            boss: this.myBoss,
            application: this.myApplication,
            salaryExpectation: this.salaryExpectation,
          },
        },
      }
      this.job.splice(this.myApplication.job.index as number, 1)
      this.top.splice(this.myApplication.top.index as number, 1)
      this.flop.splice(this.myApplication.flop.index as number, 1)
      this.sendData(data)
    },
    sendMyInitiativeApplication() {
      const data = {
        everybody: {
          id: 'initiativeApplicationReady',
          data: {
            applicant: this.name,
            boss: this.myInitiativeBoss,
            application: this.myApplication,
            salaryExpectation: this.salaryExpectation,
          },
        },
      }
      this.job.splice(this.myApplication.job.index as number, 1)
      this.top.splice(this.myApplication.top.index as number, 1)
      this.flop.splice(this.myApplication.flop.index as number, 1)
      this.sendData(data)
      this.myApplication = {
        top: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
        flop: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
        job: {
          index: undefined as number | undefined,
          name: undefined as string | undefined,
        },
      }
      this.status = PlayerGameStatus.createApplication
    },
    showApplication(index: number) {
      const data = {
        allPlayers: {
          id: 'showApplication',
          data: {
            applicationIndex: index,
          },
        },
      }
      this.sendData(data)
    },
    pickApplication(index: number) {
      const data = {
        everybody: {
          id: 'pickApplication',
          data: {
            player: this.name,
            applicationIndex: index,
          },
        },
      }
      this.sendData(data)
      this.myPick = index
      this.status = PlayerGameStatus.waitForPicks
    },

    doNextShowPicksStep() {
      if (this.applicationMatchesShown == this.applications.length) {
        const data = {} as any
        data[this.gameId + '_gameMaster'] = {
          id: 'doTheScoring',
          data: {},
        }
        this.sendData(data)
      } else {
        const data = {
          allPlayers: {
            id: this.showPicksIndex.showPickers
              ? 'showPickersForApplication'
              : 'showMatchForApplication',
            data: {
              applicationIndex: this.showPicksIndex.applicationIndex,
              pickerIndex: this.showPicksIndex.pickerIndex,
            },
          },
        }
        this.sendData(data)
      }
    },
    demandNewRound() {
      const data = {} as any
      data[this.gameId + '_gameMaster'] = {
        id: 'startNewRound',
        data: {},
      }
      this.sendData(data)
    },

    showPicksForApplication(index: number) {
      const data = {
        allPlayers: {
          id: 'showPickersForApplication',
          data: {
            applicationIndex: index,
          },
        },
      }
      this.sendData(data)
    },
    showMatchForApplication(index: number) {
      const data = {
        allPlayers: {
          id: 'showMatchForApplication',
          data: {
            applicationIndex: index,
          },
        },
      }
      this.sendData(data)
    },
    checkIfReadyForScoring() {
      if (this.applicationMatchesShown == this.applications.length) {
        const data = {} as any
        data[this.gameId + '_gameMaster'] = {
          id: 'doTheScoring',
          data: {},
        }
        this.sendData(data)
      }
    },
  },
  mounted: function() {
    this.status = PlayerGameStatus.gameStarted
    //Debug
    //Pusher.logToConsole = true

    this.pusher = new Pusher('f73f146117c4f8e6351d', {
      cluster: 'eu',
      forceTLS: true,
    })

    const channel = this.pusher.subscribe(this.gameId + '_' + this.name)
    channel.bind('player', (data: any) => {
      this.handleMessage(data)
    })

    channel.bind('pusher:subscription_succeeded', () => {
      this.sendData({ command: 'playerList' })
    })
  },
})
